import axios from '../util/request'
const md5 = require('js-md5')
import qs from 'qs'
const stamp = Date.now()

// 推荐列表
export const lgisticsList = (data) => {
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.token}${data.user_id}${atob(localStorage.getItem('key'))}`) 
  return axios.get('/interface/lgisticsList', {
    params: { ...data }
  })
}

export const applyPrize = (data) => {
  data.stamp = stamp
  data.sign = md5(`${stamp}${data.token}${data.user_id}${data.case_id}${atob(localStorage.getItem('key'))}`) 
  return axios.post('/interface/applyPrize', qs.stringify(data))
}